import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-nested-dropdown',
  templateUrl: './nested-dropdown.component.html',
  styleUrls: ['./nested-dropdown.component.scss']
})
export class NestedDropdownComponent implements OnInit {
  @Input() dropDownOptions: any[];
  @Input() currentProfession: any;
  @Output() itemSelected = new EventEmitter<any>();
  @ViewChild('nestedDropdownHolder') nestedDropdownHolder: ElementRef;

  expandedCategory: any = null;
  highlightedItem: any = null;

  constructor() { }

  ngOnInit(): void {
    console.log("NestedDropdownComponent initialized");
    console.log("DropDown Options:", this.dropDownOptions);
    console.log("currentProfession:", this.currentProfession);
    this.initializeDropdown();
  }

  initializeDropdown() {
    for (let category of this.dropDownOptions) {
      const foundItem = category.items.find(item => item.value === this.currentProfession);
      console.log(foundItem);
      if (foundItem) {
        this.expandedCategory = category;
        this.highlightedItem = foundItem;
        break;
      }
    }
  }

  handleCategoryClick(category) {
    console.log("Category clicked:", category);
    this.expandedCategory = category;
    this.scrollToTop();
  }

  handleBackClick() {
    console.log("Back button clicked");
    this.expandedCategory = null;
  }

  handleItemClick(item) {
    console.log("Item clicked:", item);
    this.itemSelected.emit(item);
    this.expandedCategory = null;
  }

  scrollToTop() {
    if (this.nestedDropdownHolder && this.nestedDropdownHolder.nativeElement) {
      this.nestedDropdownHolder.nativeElement.scrollTop = 0;
    }
  }
}
